import isArray from 'lodash/isArray';
import { Network } from '@yme/services/network';
export async function getProductByProductKey({ endpoint, keyParam, }) {
    const finallyKeysString = isArray(keyParam) ? keyParam.join('|') : keyParam;
    const finallyEndpoint = `${endpoint}&key=${finallyKeysString}`;
    const response = await Network.get(finallyEndpoint);
    return response.data;
}
